




































































































import { Component, Vue } from 'vue-property-decorator';
import { i18n } from '@/i18n';
import AddressInput from '@/components/AddressInput.vue';

@Component({
  components: {
    AddressInput,
  },
})
export default class AccountInfoTab extends Vue {
  form = {
    fields: {
      customer: {
        name: '',
        surname: '',
        phoneNumber: '',
        email: '',
        address: {
          line1: '',
          line2: '',
        },
      },
      products: [
        {
          adults: [
            { gender: 'MALE', name: '', surname: '' },
            { gender: 'MALE', name: '', surname: '' },
          ],
          displayName: 'Standart Room Sea View',
          concept: 'Ultra Herşey Dahil',
          checkInDate: new Date('2020/07/21'),
          checkOutDate: new Date('2020/07/27'),
        },
        {
          adults: [
            { gender: 'MALE', name: '', surname: '' },
            { gender: 'MALE', name: '', surname: '' },
          ],
          children: [
            { gender: 'MALE', name: '', surname: '', dateOfBirth: new Date() },
            { gender: 'MALE', name: '', surname: '', dateOfBirth: new Date() },
          ],
          displayName: 'Deluxe Room Land View',
          concept: 'Bed and Breakfast',
          checkInDate: new Date('2020/07/25'),
          checkOutDate: new Date('2020/07/29'),
        },
      ],
    },
    hasError(field: string) {
      return false;
    },
    getError(field: string) {
      return 'FALSE';
    },
  };

  get genderOptions() {
    return [
      { label: i18n.t('GENERAL.MALE'), value: 'MALE' },
      { label: i18n.t('GENERAL.FEMALE'), value: 'FEMALE' },
    ];
  }

  get customerAddressValidators() {
    return {
      country: {
        hasError: this.form.hasError('customer.address.country'),
        message: this.form.getError('customer.address.country'),
      },
      province: {
        hasError: this.form.hasError('customer.address.province'),
        message: this.form.getError('customer.address.province'),
      },
      district: {
        hasError: this.form.hasError('customer.address.district'),
        message: this.form.getError('customer.address.district'),
      },
    };
  }
}
